<div class="modal-header jobDialogHeader text-grey">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Create {{ data.appName }} Job
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-dash text-danger"
    [ngClass]="{
      'bi-dash-lg': !toogleDialog,
      'bi-fullscreen': toogleDialog,
      'minmax-dialog': toogleDialog
    }"
    color="warn"
    (click)="toogleDialogMinMax()"
    [title]="toogleDialog ? 'Maximize' : 'Minimize'"
  ></i>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger mx-3"
    color="warn"
    (click)="onCancel()"
    title="Close"
  ></i>
</div>
<div class="modal-body jobDialogBody text-grey" style="padding: 1.5rem">
  <form
    name="aimlJobForm"
    [formGroup]="aimlJobForm"
    autocomplete="off"
    spellcheck="false"
  >
    <div class="h-100 d-flex flex-column">
      <div class="flex-grow-1">
        <div class="form-row">
          <div class="form-col">
          <mat-form-field >
            <mat-label>Job name prefix (Optional)</mat-label>
            <input
              matInput
              maxlength="36"
              placeholder="Job name prefix (Optional)"
              formControlName="aiml_jobNamePrefix"
              matTooltip="Add a unique identifier that will be prefixed with job name. Only alphabets, numbers, '_', '-' , '.' , '@' allowed"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              class="matAutoCompJob"
              autoActiveFirstOption
              #auto="matAutocomplete"
            >
              <mat-option
                class="matOptionJob"
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-autocomplete>
            <mat-error
              *ngIf="aimlJobForm.get('aiml_jobNamePrefix').invalid"
              >Name Entered is not Valid.</mat-error
            >
          </mat-form-field>
         </div>
         <div class="form-col">
          <mat-form-field >
            <mat-label>Standard output file (Optional)</mat-label>
            <input
              matInput
              maxlength="20"
              placeholder="Standard output file (Optional)"
              matTooltip="Standard output and standard errors will be logged in this file. Only alphabets, numbers, '_', '-' , '.' allowed. Write readable file extension eg:[fileName.txt, fileName.xml, fileName.doc]"
              formControlName="aiml_standardOutputFile"
            />
            <mat-error
              *ngIf="aimlJobForm.get('aiml_standardOutputFile').invalid"
              >Name Entered is not Valid.</mat-error
            >
          </mat-form-field>
         </div>
       </div>
       <div class="form-row">
        <div class="form-col">
          <mat-form-field  [floatLabel]="useFixedNoOfCores ? 'always' : 'auto'">
           <mat-label>Number of Cores (Max)</mat-label>
           <mat-select
             *ngIf="useFixedNoOfCores"
             formControlName="aiml_numberOfCoresMax"
             required
             [(ngModel)]="maximumCores"
             (ngModelChange)="checkMaxCores()"
           >
             <mat-option
               *ngFor="let staticCore of staticCores"
               [value]="staticCore"
             >
               {{ staticCore }}
             </mat-option>
           </mat-select>
           <input
             matInput
             type="number"
             (mousewheel)="$event.preventDefault()"
             min="1"
             #maxInputVal
             *ngIf="!useFixedNoOfCores"
             placeholder="Number of Cores* (Max)"
             formControlName="aiml_numberOfCoresMax"
             matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
             matTooltipClass="example-tooltip-red"
             [(ngModel)]="maximumCores"
             (ngModelChange)="checkMaxCores()"
           />
           <mat-error
             *ngIf="
               aimlJobForm.get('aiml_numberOfCoresMax').touched &&
               aimlJobForm.get('aiml_numberOfCoresMax').errors
                 ?.required
             "
             >Enter Value of Maximum no. of Cores.</mat-error
           >
           <mat-error
             *ngIf="
               aimlJobForm.get('aiml_numberOfCoresMax').touched &&
               aimlJobForm.get('aiml_numberOfCoresMax').errors?.min
             "
             >Value of Maximum no. of Cores should not be in
             negative.</mat-error
           >
           <mat-error
             *ngIf="
               aimlJobForm.get('aiml_numberOfCoresMax').touched &&
               aimlJobForm.get('aiml_numberOfCoresMax').errors?.max
             "
           >
             Value of Maximum no. of Cores exceeds total no. of cores
             available.
           </mat-error>
         </mat-form-field>
        </div>
        <div class="form-col">
          <mat-form-field>
             <mat-label>Number of GPU for Job</mat-label>
             <mat-select
               *ngIf="useFixedNoOfCores"
               formControlName="aiml_numberOfCoresMax"
               required
               [(ngModel)]="maximumCores"
               (ngModelChange)="checkMaxCores()"
             >
               <mat-option
                 *ngFor="let staticCore of staticCores"
                 [value]="staticCore"
               >
                 {{ staticCore }}
               </mat-option>
             </mat-select>
             <input
               matInput
               type="number"
               (mousewheel)="$event.preventDefault()"
               min="0"
               #maxInputVal
               placeholder="Number of GPU for Job"
               formControlName="aiml_NumOfGpuForJob"
               matTooltip="Enter number of GPU to be used for job. Default : 1"
               matTooltipClass="example-tooltip-red"
             />
             <mat-error
               *ngIf="
                 aimlJobForm.get('aiml_NumOfGpuForJob').touched &&
                 aimlJobForm.get('aiml_NumOfGpuForJob').errors
                   ?.required
               "
               >Enter Value of Maximum no. of Cores.</mat-error
             >
             <mat-error
               *ngIf="
                 aimlJobForm.get('aiml_NumOfGpuForJob').touched &&
                 aimlJobForm.get('aiml_NumOfGpuForJob').errors?.min
               "
               >Value of Maximum no. of Cores should not be in
               negative.</mat-error
             >
           </mat-form-field>
        </div>
      </div>
       <div class="form-row">
         <div class="form-col">
           <mat-form-field
             appearance="fill"
             matTooltip="Select Queue"
             matTooltipPosition="above"
           >
             <mat-label>Select Node Group (Queue)</mat-label>
             <mat-select formControlName="aiml_NodeGroup" multiple>
               <mat-option
                 [disabled]="nodeGroupSelectionChange(group)"
                 *ngFor="let group of groups"
                 [value]="group"
               >
                 {{ group }}
               </mat-option>
             </mat-select>
             <mat-error
               *ngIf="
                 aimlJobForm.get('aiml_NodeGroup').touched &&
                 aimlJobForm.get('aiml_NodeGroup').errors
               "
               >Please Select Node Group (Queue).</mat-error
             >
           </mat-form-field>
         </div>
         <div class="form-col">
            <mat-form-field
                appearance="fill"
                matTooltip="Select Environment"
                matTooltipPosition="above"
              >
              <mat-label>Enter Environment</mat-label>
              <input
                matInput
                placeholder="Environment"
                formControlName="aiml_environment"
                matTooltip="Add"
                [matAutocomplete]="env"
              />
    
              <div matSuffix class="docker-link">
                <a [href]="getDockerHubUrl(aimlJobForm.get('aiml_environment').value)" 
                  target="_blank" 
                  matTooltip="Check for environments/images on Docker Hub">
                  <mat-icon>link</mat-icon>
                </a>
              </div>
  
              <mat-autocomplete
                class="matAutoCompJob"
                autoActiveFirstOption
                #env="matAutocomplete"
                        >
                <mat-option
                  class="matOptionJob"
                  *ngFor="let option of aiml_environments"
                  [value]="option"
                            >
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_environment').touched &&
                  aimlJobForm.get('aiml_environment').errors
                "
                >Please Enter Environment.</mat-error
            >
            </mat-form-field>
         </div>
       </div>
       <div class="form-row">
         <div class="form-col">
           <mat-form-field
              appearance="fill"
            >
              <mat-label>Select App Version</mat-label>
              <mat-select formControlName="aiml_versionControl">
                <mat-option *ngFor="let version of versions" [value]="version">
                  {{ version.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_versionControl').touched &&
                  aimlJobForm.get('aiml_versionControl').errors?.required
                "
                >Please Select Version.</mat-error
              >
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_versionControl').touched &&
                  aimlJobForm.get('aiml_versionControl').errors
                    ?.executeFileNull
                "
                >Execute file unavailable for selected Application
                Version.</mat-error
              >
            </mat-form-field>
         </div>
         <div class="form-col">
           <mat-form-field matTooltip="Minimum Scratch Space (Optional, In GB)."
                           matTooltipPosition="above">
             <mat-label>Minimum Scratch Space (Optional, In GB)</mat-label>
             <input matInput
                    type="number"
                    (mousewheel)="$event.preventDefault()"
                    placeholder="Minimum Scratch Space (Optional, In GB)"
                    formControlName="aiml_MinScratchSpace" />
             <mat-error *ngIf="
        aimlJobForm.get('aiml_MinScratchSpace').touched &&
        aimlJobForm.get('aiml_MinScratchSpace').errors?.pattern
      ">Please enter minimum scratch space (in GB), e.g 1.</mat-error>
           </mat-form-field> 
         </div>
       </div>
       <div class="form-row">
         <div class="form-col">
            <mat-form-field
              appearance="fill"
              matTooltip="Enter project name"
              matTooltipPosition="above"
              *ngIf="makeJobTagMandatoryFlag"
            >
              <mat-label>Add Tag</mat-label>
              <input
                type="text"
                placeholder="Enter tag e.g. Project name"
                matInput
                formControlName="aiml_Tag"
                [matAutocomplete]="tag"
              />
              <mat-autocomplete #tag="matAutocomplete">
                <mat-option
                  *ngFor="let tag of filteredTagOptions | async"
                  [value]="tag"
                >
                  {{ tag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="aimlJobForm.get('aiml_Tag').errors?.required"
                >Please Add Tag</mat-error
              >
            </mat-form-field>
         </div>
         <div class="form-col">
            <mat-form-field
              appearance="fill"
              [hidden]="!customTagName"
           
            >
              <mat-label>{{ customTagName }}</mat-label>
              <input
                type="text"
                placeholder="{{ customTagName }}"
                matInput
                formControlName="aiml_customTag"
                [matAutocomplete]="autoCustomTag"
              />
              <mat-autocomplete #autoCustomTag="matAutocomplete">
                <mat-option
                  *ngFor="let autoCustomTag of customTagValues"
                  [value]="autoCustomTag"
                >
                  {{ autoCustomTag }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="aimlJobForm.get('aiml_customTag').errors?.required"
              ></mat-error>
            </mat-form-field>
         </div>
       </div>
       <div class="form-row">
         <div class="form-col">
            <mat-form-field
              matTooltip="Enter completions count."
              matTooltipPosition="above"
            >
              <mat-label>Number of completions</mat-label>
              <input
                matInput
                type="number"
                (mousewheel)="$event.preventDefault()"
                min="0"
                placeholder="Number of completions"
                formControlName="aiml_numberOfCompletions"
              />
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_numberOfCompletions').touched &&
                  aimlJobForm.get('aiml_numberOfCompletions').errors?.pattern
                "
              >
                Please enter number of completions.
              </mat-error>
            </mat-form-field>
         </div>
         <div class="form-col">
            <mat-form-field
              matTooltip="Enter back off limit."
              matTooltipPosition="above"
            >
              <mat-label>Back off limit</mat-label>
              <input
                matInput
                type="number"
                (mousewheel)="$event.preventDefault()"
                min="0"
                placeholder="Back off limit"
                formControlName="aiml_backOffLimit"
              />
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_backOffLimit').touched &&
                  aimlJobForm.get('aiml_backOffLimit').errors?.pattern
                "
              >
                Please enter back off limit.
              </mat-error>
            </mat-form-field>
         </div>
       </div>
       <div class="form-row">
         <div class="form-col">
           <mat-form-field
                           appearance="fill"
             >
             <mat-label>Select Priority</mat-label>
             <mat-select formControlName="aiml_Priority" required>
               <mat-option
                  *ngFor="let priority of priorities"
                  [value]="priority"
                           >
                 {{ priority }}
               </mat-option>
             </mat-select>
             <mat-error
                *ngIf="
                   aimlJobForm.get('aiml_Priority').touched &&
                   aimlJobForm.get('aiml_Priority').errors
                  "
               >Please Select Priority.</mat-error
             >
           </mat-form-field>
         </div>
         <div class="form-col">
            <mat-form-field class="d-none" >
              <mat-label>Number of Cores (Min)</mat-label>
              <mat-select
                *ngIf="useFixedNoOfCores"
                [(ngModel)]="minimumCores"
                (ngModelChange)="checkMinCores()"
                formControlName="aiml_numberOfCoresMin"
                required
              >
                <mat-option
                  *ngFor="let staticCore of staticCores"
                  [value]="staticCore"
                >
                  {{ staticCore }}
                </mat-option>
              </mat-select>
              <input
                matInput
                type="number"
                (mousewheel)="$event.preventDefault()"
                min="1"
                #minInputVal
                *ngIf="!useFixedNoOfCores"
                placeholder="Number of Cores (Min)"
                matTooltip="Add number of cores on which job should run. Maximum cores are required, Minimum cores are optional. If given Max cores are not available then given Min cores will be used for job. If those are also not available, job will be kept in queue."
                formControlName="aiml_numberOfCoresMin"
                [(ngModel)]="minimumCores"
                (ngModelChange)="checkMinCores()"
              />
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_numberOfCoresMin').touched &&
                  aimlJobForm.get('aiml_numberOfCoresMin').errors
                    ?.required
                "
                >Enter Value of Minimum no. of Cores.</mat-error
              >
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_numberOfCoresMin').touched &&
                  aimlJobForm.get('aiml_numberOfCoresMin').errors
                    ?.invalidCore
                "
              >
                Minimum cores should be lesser than or equal to Maximum Cores.
              </mat-error>
              <mat-error
                *ngIf="
                  aimlJobForm.get('aiml_numberOfCoresMin').touched &&
                  aimlJobForm.get('aiml_numberOfCoresMin').errors?.min
                "
                >Value of Minimum no. of Cores should not be in
                negative.</mat-error
              >
            </mat-form-field>  
         </div>
       </div>

        <div
          *ngIf="formData"
          style="display: flex; flex-wrap: wrap; margin-bottom: 0.5rem"
        >
          <div
            *ngFor="let control of formData.Controls"
            [ngStyle]="{
              width: control.Type == 'inputFile' ? '100%' : '50%'
            }"
          >
            <div
              [ngStyle]="{
                marginLeft: control.Type == 'inputFile' ? '1%' : '2%'
              }"
              style="margin-bottom: 1rem"
            >
              <!-- dropdown -->
              <mat-form-field
                *ngIf="control.Type == 'dropdown'"
                appearance="fill"
                style="width: 98%"
              >
                <mat-label>{{ control.Label }}</mat-label>
                <mat-select [formControlName]="control.Name">
                  <mat-option
                    *ngFor="let val of control.AddValue"
                    [value]="val"
                  >
                    {{ val }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- checkbox -->
              <mat-checkbox
                *ngIf="control.Type == 'checkbox'"
                [formControlName]="control.Name"
                class="mt-2"
                [title]="control.Label"
                style="display: inline-flex"
              >
                {{ control.Label }}
              </mat-checkbox>

              <!-- input text -->
              <mat-form-field
                style="width: 98%"
                *ngIf="['textbox'].includes(control.Type)"
              >
                <mat-label>{{ control.Label }}</mat-label>
                <input
                  matInput
                  [placeholder]="control.Label"
                  type="text"
                  [formControlName]="control.Name"
                  [value]="control.Value"
                  [matTooltip]="control.tooltip"
                />
                <mat-error *ngIf="aimlJobForm.get(control.Name).invalid">
                  {{ control.ErrorMsg }}
                </mat-error>
              </mat-form-field>

              <!-- upload files -->
              <mat-form-field
                *ngIf="control.Type === 'inputFile'"
                style="
                  width: 48%;
                  margin-top: 0.4rem;
                  background: var(--s-menuHover-color);
                "
                class="me-5"
              >
                <mat-label>{{ control.Label }}</mat-label>
                <input
                  readonly
                  matInput
                  [placeholder]="control.Label"
                  [formControlName]="control.Name"
                  (ngModelChange)="updateJobName($event)"
                  matTooltip="Select input file"
                  matTooltipClass="example-tooltip-red"
                />
                <mat-error
                  *ngIf="
                    aimlJobForm.get(control.Name).touched &&
                    aimlJobForm.get(control.Name).errors?.required
                  "
                  >{{ control.ErrorMsg }}</mat-error
                >
              </mat-form-field>

              <!-- upload files -->
              <div
                *ngIf="control.Type === 'inputFile'"
                style="display: inline-flex; align-items: center"
              >
                <div style="height: 22px; margin-left: 5px; width: 18px">
                  <a
                    title="Remove"
                    style="cursor: pointer"
                    *ngIf="
                      aimlJobForm.get(control.Name).value != null &&
                      aimlJobForm.get(control.Name).value != ''
                    "
                    (click)="removeFile(control.Name)"
                  >
                    <span
                      class="bi bi-x-lg text-danger"
                      aria-hidden="true"
                      style="color: red; font-size: 18px"
                    >
                    </span>
                  </a>
                </div>
                <input
                  type="button"
                  value="Use SyncStore"
                  (click)="loadSyncStoreFileTree(control.Name)"
                  id="inputSyncStoreSelectFile"
                  class="uploadBtn"
                  style="font-size: 12px; margin-left: 5px; outline: none"
                />
                <input
                  type="file"
                  [name]="control.Name"
                  [id]="control.Name"
                  style="display: none; font-size: 12px; width: 90px"
                  #workStoreSelect_aiml_journalFile
                  (click)="onFileChange(control.Name)"
                  (onFileSelected)="startNg2Upload($event, control.Name)"
                  ng2FileSelect
                  [uploader]="uploader"
                />
                <!-- <label class="dynamicUploadBtn" [for]="control.Name"
                  >Upload File</label
                > -->
                 <button
                      type="button"
                      #lDynaRestartFile
                      class="uploadBtn pull-right"
                      style="margin-left: 5px; outline: none"
                      [for]="control.Name"
                      (click)="workStoreSelect_aiml_journalFile.click()"
                    >
                      <span class="bi bi-cloud-arrow-up-fill"></span>
                      Upload File
                    </button>
                <p
                  *ngIf="
                    jobInputIds[control.Name] != null &&
                    cloudType == 'On-Premise'
                  "
                  style="margin: 0 0 0 15px !important"
                  class="uploadPercentage"
                >
                  {{ jobInputIds[control.Name] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds[control.Name] + '%' }}
                </p>
                <p
                  *ngIf="
                    jobInputIds[control.Name] != null &&
                    cloudType != 'On-Premise'
                  "
                  style="margin: 0 0 0 15px !important"
                  class="uploadPercentage"
                >
                  {{ jobInputIds[control.Name] }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <h3>File Settings</h3>

        <mat-form-field
          style="width: 48%; background: var(--s-menuHover-color)"
        >
          <mat-label>Script File</mat-label>
          <input
            readonly
            matInput
            placeholder="Script File"
            (ngModelChange)="updateJobName($event)"
            formControlName="aiml_scriptFile"
            matTooltip="Select Script (.py/.sh) file name."
            matTooltipClass="example-tooltip-red"
          />
          <mat-error
            *ngIf="
              aimlJobForm.get('aiml_scriptFile').touched &&
              aimlJobForm.get('aiml_scriptFile').errors?.required
            "
            >Enter Script File.</mat-error
          >
          <mat-error
            *ngIf="
              aimlJobForm.get('aiml_scriptFile').touched &&
              aimlJobForm.get('aiml_scriptFile').errors?.uploadFailed
            "
            >Script File Required.</mat-error
          >
        </mat-form-field>

        <div style="display: inline-flex; align-items: center">
          <div style="height: 22px; margin-left: 5px; width: 18px">
            <a
              title="Remove"
              style="cursor: pointer"
              *ngIf="aimlJobForm.get('aiml_scriptFile').value != null"
              (click)="removeFile('aiml_scriptFile')"
            >
              <span
                class="bi bi-x-lg text-danger"
                aria-hidden="true"
                style="color: red; font-size: 18px"
              >
              </span>
            </a>
          </div>
          <input
            type="button"
            value="Use SyncStore"
            (click)="loadSyncStoreFileTree('aiml_scriptFile')"
            #syncStoreSelect_aiml_scriptFile
            class="uploadBtn"
            style="font-size: 12px; margin-left: 5px; outline: none"
            [disabled]="aimlJobForm.get('aiml_scriptFile').value != null"
          />
          <input
            type="file"
            #workStoreSelect_aiml_scriptFile
            (click)="onFileChange('workStoreSelect_aiml_scriptFile')"
            style="display: none; font-size: 12px; width: 90px"
            (onFileSelected)="startNg2Upload($event, 'aiml_scriptFile')"
            ng2FileSelect
            [uploader]="uploader"
          />
          <button
            type="button"
            title="Select and upload files to working directory"
            class="uploadBtn pull-right"
            style="margin-left: 5px; outline: none"
            (click)="workStoreSelect_aiml_scriptFile.click()"
            [disabled]="aimlJobForm.get('aiml_scriptFile').value != null"
          >
            <span class="bi bi-cloud-arrow-up-fill"></span>
            Upload File
          </button>
          <p
            *ngIf="
              jobInputIds['aiml_scriptFile'] != null &&
              cloudType == 'On-Premise'
            "
            style="margin: 0 0 0 15px !important"
            class="uploadPercentage"
          >
            {{ jobInputIds["aiml_scriptFile"] === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + jobInputIds["aiml_scriptFile"] + '%' }}
          </p>
          <p
            *ngIf="
              jobInputIds['aiml_scriptFile'] != null &&
              cloudType != 'On-Premise'
            "
            style="margin: 0 0 0 15px !important"
            class="uploadPercentage"
          >
            {{ jobInputIds["aiml_scriptFile"] }}
          </p>
        </div>

        <div style="margin-top: 1%">
          <table
            id="aiml_inputFileTable"
            class="table table-bordered additionalInputs"
            style="
              overflow-y: scroll;
              height: 150px;
              display: block;
              background-color: #f5f5f5;
              padding: 0px;
            "
          >
            <tbody>
              <tr>
                <td style="width: 10%">
                  <span>Additional Input Files :</span>
                </td>
                <td style="width: 35%; text-align: end">
                  <button
                    type="button"
                    id="btnUploadFile"
                    title="Select and upload files to working directory"
                    class="uploadBtn pull-right"
                    style="outline: none"
                    (click)="openFileEditor()"
                    *ngIf="isHeadNodeLinux"
                  >
                    <span class="bi bi-pencil"></span>
                    New File
                  </button>
                  <input
                    multiple
                    type="file"
                    #workStoreSelect_aiml_inputScriptFile
                    (click)="
                      onFileChange('workStoreSelect_aiml_inputScriptFile')
                    "
                    style="display: none; font-size: 12px; width: 90px"
                    (onFileSelected)="startNg2Upload($event)"
                    ng2FileSelect
                    [uploader]="uploader"
                  />
                  <input
                    type="button"
                    name="commandBtnSyncStore"
                    value="Use SyncStore"
                    (click)="loadSyncStoreFileTree()"
                    id="commandBtnSyncStore"
                    class="uploadBtn pull-right"
                    style="font-size: 12px; outline: none"
                  />
                  <button
                    type="button"
                    id="btnUploadFile"
                    title="Select and upload files to working directory"
                    class="uploadBtn pull-right"
                    style="outline: none"
                    (click)="workStoreSelect_aiml_inputScriptFile.click()"
                  >
                    <span class="bi bi-cloud-arrow-up-fill"></span>
                    Upload File(s)
                  </button>
                </td>
              </tr>
              <tr
                *ngFor="let inputFile of jobAdditionalInputFiles; let i = index"
              >
                <td><span>File Name :</span></td>
                <td>
                  <span title="{{ inputFile.path }}">{{ inputFile.name }}</span>
                  <button
                    #cancelUpload
                    title="Remove File"
                    type="button"
                    style="margin-left: 5px"
                    id="cancel{{ i }}"
                    (click)="removeItem(inputFile)"
                  >
                    <span
                      class="bi bi-x-lg text-danger"
                      style="color: brown"
                    ></span>
                  </button>
                  <button
                    #editFile
                    title="Edit File"
                    type="button"
                    style="margin-left: 5px"
                    id="edit{{ i }}"
                    (click)="editItem(inputFile)"
                    *ngIf="
                      inputFile?.isUploadCompleted &&
                      inputFile.type == 'file' &&
                      isHeadNodeLinux
                    "
                  >
                    <span
                      class="bi bi-pencil-square text-danger"
                      style="color: brown"
                    ></span>
                  </button>
                  <span
                    *ngIf="
                      inputFile.value != undefined &&
                      cloudType != 'Microsoft Azure'
                    "
                    class="uploadPercentage"
                    >{{ inputFile.value === 'Starting' ? 'Upload : Starting...' : 'Uploaded : ' + inputFile.value + '%' }}</span
                  >
                  <span
                    *ngIf="
                      inputFile.value != undefined &&
                      cloudType == 'Microsoft Azure'
                    "
                    class="uploadPercentage"
                    >{{ inputFile.value }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <mat-checkbox
          formControlName="aiml_BackupData"
          style="margin-left: 32%"
        >
          Copy output data of job to Syncstore
        </mat-checkbox>
        <mat-checkbox
          formControlName="aiml_keepWorkStoreData"
          style="margin-left: 32%"
        >
          Keep job data in workstore after job completion
        </mat-checkbox>
      </div>
    </div>

    <!--<mat-checkbox
    title="Stop all compute nodes after job completion"
    formControlName="aiml_autoShut"
    style="margin-left: 32%"
    >Stop all compute nodes after job completion</mat-checkbox
  >-->

    <div style="display: flex; display: none">
      <mat-checkbox
        formControlName="aiml_jobSchedule"
        class="well well-sm"
        title="Schedule this Job"
        style="padding-left: 32%; display: inline-flex"
      >
        Schedule this job for later,
      </mat-checkbox>
      <input
        matInput
        style="
          margin-left: 2%;
          color: var(--s-primary-color);
          width: 28%;
          border-bottom: 1px solid black;
        "
        formControlName="aiml_customDate"
        placeholder="Job will be executed at the given time."
        type="datetime-local"
        value=""
        [min]="todayDate"
        [max]="maxDate"
      />
    </div>
  </form>
</div>
<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex w-50 align-items-center">
      <mat-form-field class="flex-grow-1">
        <mat-label>Job template name (Optional)</mat-label>
        <input
          type="text"
          name="jobTemplateName"
          [(ngModel)]="jobTemplateNameValue"
          title="Enter template name to save and use these settings later."
          matInput
        />
      </mat-form-field>

      <button
        *ngIf="!isTemplateNameBeingEdited"
        class="default-btn ms-2"
        style="border: 1px solid #0072c6"
        title="Save Template"
        (click)="saveJobTemplate()"
      >
        <span class="bi bi-journal-code"></span> Save
      </button>

      <button
        *ngIf="isTemplateNameBeingEdited"
        class="default-btn ms-2"
        style="border: 1px solid #0072c6"
        title="Update Template"
        (click)="saveJobTemplate()"
      >
        <span class="bi bi-journal-code"></span> Update
      </button>
    </div>

    <div class="d-flex d-flex justify-content-end w-100">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="onCancel()"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-primary ms-2"
        [title]="
          !isHeadnodeActive
            ? 'Job cannot be submitted. Headnode not active.'
            : 'Submit Job'
        "
        [disabled]="
          isUploadActive || isHeadnodeActive == false || autoSubmitAfterUpload
        "
        (click)="onSubmit(aimlJobForm)"
      >
        Submit
      </button>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="resubmitJob"
>
  <p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
